
/* injects from baggage-loader */

'use strict';

export default class SignupController {

	constructor($log, $state, $location, $timeout, $stateParams, User) {
		'ngInject';

		this.$log = $log;
		this.$state = $state;
		this.$location = $location;
		this.$timeout = $timeout;
		this.UserService = User;

		// Hold user login credentials
		this.user = {
			// first_name: 'Mitch',
			// last_name: 'Skomra',
			// email: 'mskomra@madsimple.io',
			// password: 'pass',
			// password_verify: 'pass'
		};

		// Hold login error details
		this.error = {};

		// Get the referral page from state params
		this.referral = $stateParams.ref;

		// this.creating_account = true;

	}

	$onInit() {

	}

	signup() {

		// Reset error
		this.error = {};

		if (!this.user.first_name) {
			this.error.message = 'Missing "first name"';
			return;
		}
		if (!this.user.last_name) {
			this.error.message = 'Missing "last name"';
			return;
		}

		if (!this.user.email) {
			this.error.message = 'Missing "email"';
			return;
		}
		if (!this.user.password || !this.user.password_verify) {
			this.error.message = 'Missing "password"';
			return;
		}

		if (this.user.password !== this.user.password_verify) {
			this.error.message = 'The passwords do not match';
			return;
		}

		this.creating_account = true;

		// try {

		// // Attempt to authenticate the user
		// let user = await this.UserService.signup(this.user);

		// if (typeof this.referral !== 'undefined') {
		// 	this.$location.path(this.referral).search({});
		// } else {
		// 	this.$state.go('account.profile');
		// }

		// } catch(err) {
		// 	this.creating_account = true;
		// 	this.error = err;
		// 	this.$timeout();
		// }

		this.UserService.signup(this.user)
			.then(user => {
				if (typeof this.referral !== 'undefined') {
					this.$location.path(this.referral).search({});
				} else {
					this.$state.go('account.profile');
				}
			})
			.catch(err => {
				this.creating_account = false;
				this.error = err;
				this.$timeout();
			});

	}


}



// WEBPACK FOOTER //
// ./src/app/pages/signup/signup.controller.js